import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DASHBOARD_ADHOC_REPORT, LIST_VIEW_LIMIT } from "../../../constants";
import { getBiReportsListAsync } from "../../../app/patientSlice";
import { Pagination } from "../../secondary";
import { Pagination as assignedPagination } from "../../../utils";
import style from "./biReportsList.module.scss";
import Spreadsheet from "../../../static/images/ExportSpredsheet.svg";
import { format } from "date-fns";
import DataTableV2 from "../../secondary/DataTable/DataTableV2";
import { useLoading } from "../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../constants/loadingKeys";

const BiReportsList = () => { //NOSONAR
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const biReportLoading = useLoading(LOADING_KEYS.BI_REPORT_LIST);

  const biReportsListData = useSelector((state) => state.patient.biReportsList);
  const biReportSummaryCsvData = useSelector(
    (state) => state.patient.biReportSummaryCsv
  );
  // const biReportDetailCsvData = useSelector(
  //   (state) => state.patient.biReportDetailCsv
  // );

  const [sortBy, setSortBy] = useState({ column: null, direction: null });

  const columns = [
    { Header: "Facility", accessor: "facilityName", width: "280px", sortable: true },
    { Header: "MRN #", accessor: "mrn", width: "150px", sortable: true },
    { Header: "Patient", accessor: "patientName", width: "200px", sortable: true },
    { Header: "Wound", accessor: "anatomy", width: "250px", sortable: true },
    { Header: "Etiology", accessor: "historyCause", width: "250px", sortable: true },
    { Header: "DOB", accessor: "dob", width: "150px", sortable: true },
    { Header: "Admission date", accessor: "admissionDate", width: "150px", sortable: true },
    { Header: "Discharge date", accessor: "dischargeDate", width: "150px", sortable: true },
    { Header: "Last assessed", accessor: "lastAssessed", width: "170px", sortable: true },
    { Header: "Status", accessor: "woundProgress", width: "180px", sortable: true },
    { Header: "Trend", accessor: "woundTrend", width: "150px", sortable: true },
    { Header: "Wound acquired", accessor: "woundAcquired", width: "200px", sortable: true },
    { Header: "Photo taken by", accessor: "woundPhotoTakenBy", width: "180px", sortable: true },
    { Header: "Photo taken on", accessor: "woundPhotoTakenOn", width: "190px", sortable: true },
    { Header: "Surface area", accessor: "surfaceArea", width: "150px", sortable: true },
    { Header: "Length", accessor: "length", width: "150px", sortable: true },
    { Header: "Width", accessor: "width", width: "150px", sortable: true },
    { Header: "Depth", accessor: "depth", width: "150px", sortable: true },
    { Header: "Tuneling", accessor: "tuneling", width: "150px", sortable: true },
    { Header: "Undermining", accessor: "undermining", width: "150px", sortable: true },
    { Header: "Photo type", accessor: "photoType", width: "150px", sortable: true },
    { Header: "Documentation type", accessor: "documentationType", width: "200px", sortable: true },
    { Header: "Wound age", accessor: "woundAge", width: "150px", sortable: true },
    { Header: "Tissue type", accessor: "tissueType", width: "150px", sortable: true },
    { Header: "Are there any open areas", accessor: "areThereAnyOpenAreas", width: "200px", sortable: true },
    { Header: "Evidence of infection?", accessor: "woundAtRiskOfInfection", width: "200px", sortable: true },
    { Header: "Exudate type", accessor: "exudateType", width: "150px", sortable: true },
    { Header: "Exudate amount", accessor: "exudateAmount", width: "150px", sortable: true },
    { Header: "Wound bed identified", accessor: "woundbedIdentified", width: "180px", sortable: true },
    { Header: "Classification", accessor: "woundClassification", width: "180px", sortable: true },
    { Header: "Intervention", accessor: "interventionName", width: "170px", sortable: true },
    { Header: "Dressing appearance", accessor: "dressingAppearance", width: "180px", sortable: true },
    { Header: "Debridement", accessor: "debridement", width: "150px", sortable: true },
    { Header: "Wound cleanser", accessor: "woundCleanser", width: "150px", sortable: true },
    { Header: "Skin protectant", accessor: "skinProtectant", width: "150px", sortable: true },
    { Header: "Primary dressing", accessor: "primaryDressing", width: "150px", sortable: true },
    { Header: "Secondary dressing", accessor: "secondaryDressing", width: "170px", sortable: true },
    { Header: "Compression", accessor: "compression", width: "150px", sortable: true },
    { Header: "Modalities", accessor: "modalities", width: "150px", sortable: true },
    { Header: "Additional care", accessor: "additionalCare", width: "160px", sortable: true },
    { Header: "Dressing change frequency", accessor: "dressingChangeFrequency", width: "210px", sortable: true },
  ];



  const getSelectedRowData = (data) => {
    if (data) {
      navigate(`/${"patients"}/${data.ne1Id}/${"assessment"}/${data.woundId}`);
    }
  };

  // const fileHeaders = [    
  //   { label: "Ne1 Id", key: "ne1Id" },
  //   { label: "Wound acquired", key: "woundAcquired" },
  //   { label: "Re-eval Id", key: "revalId" },
  //   { label: "Wound number", key: "woundNumber" },
  //   { label: "MRN #", key: "mrn" },
  //   { label: "Patient\'s name", key: "patientName" },
  //   { label: "DOB", key: "dob" },
  //   { label: "Facility/Location", key: "facilityLocation" },
  //   { label: "Admission date", key: "admissionDate" },
  //   { label: "Discharge date", key: "dischargeDate" },
  //   { label: "Wound photo taken by", key: "woundPhotoTakenBy" },
  //   { label: "Wound photo taken on", key: "woundPhotoTakenOn" },
  //   { label: "Last assessed", key: "lastAssessed" },
  //   { label: "Surface area​", key: "surfaceArea" },
  //   { label: "Length​", key: "length" },
  //   { label: "Width", key: "width" },
  //   { label: "Depth", key: "depth" },
  //   { label: "Tuneling", key: "tuneling" },
  //   { label: "Undermining", key: "undermining" },
  //   { label: "HPR 1", key: "hpr1" },
  //   { label: "HPR 2​", key: "hpr2" },
  //   { label: "HPR 3", key: "hpr3" },
  //   { label: "History/Cause", key: "historyCause" },
  //   { label: "Anatomy", key: "anatomy" },
  //   { label: "Condition POA", key: "conditionPOA" },
  //   { label: "Photo type", key: "photoType​" },
  //   { label: "Documentation type​​", key: "documentationType" },
  //   { label: "Wound age", key: "woundAge" },
  //   { label: "Tissue type", key: "tissueType" },
  //   { label: "Are there any open areas", key: "areThereAnyOpenAreas" },
  //   { label: "Evidence of infection?", key: "woundAtRiskOfInfection" },
  //   { label: "Exudate type​​", key: "exudateType" },
  //   { label: "Exudate amount​​​", key: "exudateAmount" },
  //   { label: "Wound bed identified", key: "woundbedIdentified" },
  //   { label: "Wound classification", key: "woundClassification​​" },
  //   { label: "Wound progress", key: "woundProgress" },
  //   { label: "Intervention name​​", key: "interventionName" },
  //   { label: "Last updated by", key: "lastUpdatedBy​" },
  //   { label: "Last updated on​​​", key: "lastUpdatedOn" },
  //   { label: "Dressing appearance", key: "dressingAppearance​" },
  //   { label: "Debridement​​", key: "debridement​" },
  //   { label: "Wound cleanser", key: "woundCleanser" },
  //   { label: "Skin protectant", key: "skinProtectant" },
  //   { label: "Primary dressing", key: "primaryDressing​" },
  //   { label: "Secondary dressing", key: "secondaryDressing​​" },
  //   { label: "Compression", key: "compression​​​" },
  //   { label: "Modalities​​", key: "modalities​​" },
  //   { label: "Additional care", key: "additionalCare​" },
  //   { label: "Dressing change frequency", key: "dressingChangeFrequency​" },
  // ];

  // const [csvHeader, setCsvHeader] = useState([
  //   { label: "Ne1 Id", key: "ne1Id" },
  //   { label: "Wound acquired", key: "woundAcquired" },
  //   { label: "Re-eval Id", key: "revalId" },
  //   { label: "Wound number", key: "woundNumber" },
  //   { label: "MRN #", key: "mrn" },
  //   { label: "Patient\'s name", key: "patientName" },
  //   { label: "DOB", key: "dob" },
  //   { label: "Facility/Location", key: "facilityLocation" },
  //   { label: "Admission date", key: "admissionDate" },
  //   { label: "Discharge date", key: "dischargeDate" },
  //   { label: "Wound photo taken by", key: "woundPhotoTakenBy" },
  //   { label: "Wound photo taken on", key: "woundPhotoTakenOn" },
  //   { label: "Last assessed", key: "lastAssessed" },
  //   { label: "Last updated by", key: "lastUpdatedBy" },
  //   { label: "Last updated on", key: "lastUpdatedOn" },
  //   { label: "Surface area​", key: "surfaceArea" },
  //   { label: "Length​", key: "length" },
  //   { label: "Width", key: "width" },
  //   { label: "Depth", key: "depth" },
  //   { label: "Tuneling", key: "tuneling" },
  //   { label: "Undermining", key: "undermining" },
  //   { label: "HPR 1", key: "hpr1" },
  //   { label: "HPR 2​", key: "hpr2" },
  //   { label: "HPR 3", key: "hpr3" },
  //   { label: "History/Cause", key: "historyCause" },
  //   { label: "Anatomy", key: "anatomy" },
  //   { label: "Condition POA", key: "conditionPOA" },
  //   { label: "Photo type", key: "photoType​" },
  //   { label: "Documentation type​​", key: "documentationType" },
  //   { label: "Wound age", key: "woundAge" },
  //   { label: "Tissue type", key: "tissueType" },
  //   { label: "Are there any open areas", key: "areThereAnyOpenAreas" },
  //   { label: "Evidence of infection?", key: "woundAtRiskOfInfection" },
  //   { label: "Exudate type​​", key: "exudateType" },
  //   { label: "Exudate amount​​​", key: "exudateAmount" },
  //   { label: "Wound bed identified", key: "woundbedIdentified​" },
  //   { label: "Wound classification", key: "woundClassification" },
  //   { label: "Wound progress", key: "woundProgress" },
  // ]);

  // pagination
  const [activePage, setActivePage] = useState(1);
  // const [csvData, setCsvData] = useState(null);
  const [offSet, setOffSet] = useState(0)
  const [sortType, setSortType] = useState('')
  // const [numberOfintervention, setNumberOfintervention] = useState(0); // State for mainaining number of intervention each row has

  const getActivePage = (data) => {
    setOffSet((((data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT) < LIST_VIEW_LIMIT) ? 0 : (data * LIST_VIEW_LIMIT) - LIST_VIEW_LIMIT)
    assignedPagination(
      data,
      setActivePage,
      DASHBOARD_ADHOC_REPORT,
      "POST",
      LIST_VIEW_LIMIT,
      dispatch,
      getBiReportsListAsync,
      "",
      biReportsListData?.Postdata,
      sortType
    );
  };
  const handleSort = (data) => {
    let sortingColumn = data.sortBy[0]
    let sortingType = sortingColumn ? (sortingColumn.desc) ? ':DESC' : ':ASC' : ''
    setSortType((sortingColumn) && sortingColumn.id + sortingType)
    let sortingList = {};
    sortingList['url'] = DASHBOARD_ADHOC_REPORT
    sortingList['method'] =  "POST"
    sortingList['queryParam'] = { limit: LIST_VIEW_LIMIT, offSet: isNaN(offSet)===true?0:offSet,sort: (sortingColumn) && sortingColumn.id + sortingType }
    sortingList['reportData'] =  biReportsListData?.Postdata
    dispatch(getBiReportsListAsync(sortingList))
  };
 
  // useEffect(() => {
  //   if (
  //     biReportDetailCsvData &&
  //     biReportDetailCsvData?.reports &&
  //     biReportDetailCsvData?.reports?.length > 0
  //   ) {
  //     const temp = [...biReportDetailCsvData.reports];
  //     const res = [];
  //     let max = 0;
  //     biReportDetailCsvData?.reports?.forEach((data, i) => { //NOSONAR
  //       const test = { ...temp[i] };
  //       // We need to pass header dynamically
  //       if (data?.interventions?.length > max) {
  //         max = data.interventions.length;
  //       }
  //       data.interventions &&
  //         data.interventions.length > 0 &&
  //         data.interventions.forEach((data, qi) => { //NOSONAR
  //           test["additionalCare " + (qi + 1)] = data.additionalCare;
  //           test["compression" + (qi + 1)] = data.compression;
  //           test["debridement" + (qi + 1)] = data.debridement;
  //           test["dressingAppearance" + (qi + 1)] = data.dressingAppearance;
  //           test["dressingChangeFrequency" + (qi + 1)] =
  //             data.dressingChangeFrequency;
  //           test["interventionName" + (qi + 1)] = data.interventionName;
  //           test["modalities" + (qi + 1)] = data.modalities;
  //           test["primaryDressing" + (qi + 1)] = data.secondaryDressing;
  //           test["secondaryDressing" + (qi + 1)] = data.compression;
  //           test["skinProtectant" + (qi + 1)] = data.skinProtectant;
  //           test["woundCleanser" + (qi + 1)] = data.woundCleanser;
  //         })//NOSONAR
  //       res.push(test);
  //     })//NOSONAR
  //     if (max >= 6) {
  //       setNumberOfintervention(6);
  //     } else {
  //       setNumberOfintervention(max);
  //     }
  //     setCsvData([...res]);
  //   }
  // }, [biReportDetailCsvData]);

  // useEffect(() => {
  //   if (numberOfintervention > 0) {
  //     const temp = [];
  //     for (let i = 1; i <= numberOfintervention; i++) {
  //       temp.push({ label: "Additional Care" + i, key: "additionalCare" + i });
  //       temp.push({ label: "Compression" + i, key: "compression" + i });
  //       temp.push({ label: "Debridement" + i, key: "debridement" + i });
  //       temp.push({
  //         label: "Dressing Appearance" + i,
  //         key: "dressingAppearance" + i,
  //       });
  //       temp.push({
  //         label: "Dressing Change Frequency" + i,
  //         key: "dressingChangeFrequency" + i,
  //       });
  //       temp.push({
  //         label: "Intervention Name" + i,
  //         key: "interventionName" + i,
  //       });
  //       temp.push({ label: "Modalities" + i, key: "modalities" + i });
  //       temp.push({
  //         label: "Primary Dressing" + i,
  //         key: "primaryDressing" + i,
  //       });
  //       temp.push({
  //         label: "Secondary Dressing" + i,
  //         key: "secondaryDressing" + i,
  //       });
  //       temp.push({ label: "Skin Protectant" + i, key: "skinProtectant" + i });
  //       temp.push({ label: "Wound Cleanser" + i, key: "woundCleanser" + i });
  //     }
  //     setCsvHeader([...csvHeader, ...temp]);
  //   }
  // }, [numberOfintervention]); 

  const onSort = (column, direction) => {
    if (!column || !direction) return;
    setSortBy({ column, direction });
    handleSort({ sortBy: [{ id: column, desc: direction === "desc" }] });
  };

  const handleDownload = () => {
    if (!biReportSummaryCsvData?.downloadUrl) return; 
    const link = document.createElement("a");
  
    link.href = biReportSummaryCsvData?.downloadUrl;
    link.download = biReportSummaryCsvData?.fileName;
  
    document.body.appendChild(link);
    link.click();
  
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="col-12">
        {biReportsListData && Array.isArray(biReportsListData?.reports) && (
          <>
            <div className="col-sm-12 mb-2 justify-content-end d-flex ">
              <button className={`mr-1 ${style.down_spread}`} onClick={handleDownload}>
                <img src={Spreadsheet} alt="download_icon" className="mr-2" />
                Download
              </button>
            </div>
            <DataTableV2
              columns={columns}
              data={biReportsListData && Array.isArray(biReportsListData?.reports) ? biReportsListData?.reports : []}
              onRowClick={getSelectedRowData}
              sortBy={sortBy}
              onSort={onSort}
              loading={biReportLoading}
              emptyMessage="There are no records in this list"
            />
            <Pagination
              activePage={activePage}
              itemsCountPerPage={biReportsListData?.metadata ? biReportsListData?.metadata?.limit : 50}
              totalItemsCount={biReportsListData?.metadata ? biReportsListData?.metadata?.total : 0}
              getActivePage={getActivePage}
            />
          </>
        )}
      </div>
    </>
  );
}//NOSONAR

export default BiReportsList;